import Vue from 'vue'

export default {
  SET_CONFIG(state, payload) {
    state.config = payload
  },
  SET_CATEGORIES(state, payload) {
    state.categories = payload
  },
  SET_LAST_TEST(state, payload) {
    state.lastTest = payload
  },
  SET_LAST_STOCK_SYNC(state, payload) {
    state.lastStockSync = payload
  },
  SET_CATEGORY_BUSY(state, { id, busy }) {
    if (busy) {
      Vue.set(state.busyCategoryIds, id, true)
    } else {
      Vue.delete(state.busyCategoryIds, id)
    }
  },
  SET_LOADING_CATEGORIES(state, v) {
    state.loadingCategories = v
  },
  SET_LOADING_CONFIG(state, v) {
    state.loadingConfig = v
  },
  UPDATE_CATEGORY(state, payload) {
    const idx = state.categories.findIndex(c => c.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.categories, idx, { ...state.categories[idx], ...payload })
    }
  },
}
